'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiddlewareManager = function () {
    function MiddlewareManager() {
        (0, _classCallCheck3.default)(this, MiddlewareManager);
        this.middlewares = [_request2.default];
    }

    (0, _createClass3.default)(MiddlewareManager, [{
        key: 'use',
        value: function use(middleware) {
            if (typeof middleware !== 'function') {
                throw new TypeError('Middleware must be composed of functions!');
            }
            this.middlewares.splice(this.middlewares.length - 1, 0, middleware);
        }

        // 请求发出，run所有的middleware
        // fork from https://github.com/koajs/compose/blob/master/index.js

    }, {
        key: 'run',
        value: function run(ctx, next) {
            var middlewares = this.middlewares;

            var index = -1;

            return dispatch(0);
            function dispatch(i) {
                if (i <= index) {
                    return Promise.reject(new Error('next() called multiple times'));
                }
                index = i;
                var fn = middlewares[i];
                if (i === middlewares.length) {
                    fn = next;
                }

                if (!fn) {
                    return Promise.resolve();
                }

                try {
                    return Promise.resolve(fn(ctx, dispatch.bind(null, i + 1)));
                } catch (err) {
                    return Promise.reject(err);
                }
            }
        }
    }]);
    return MiddlewareManager;
}();

exports.default = MiddlewareManager;